import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useEffect  } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import useMediaQuery from "@mui/material/useMediaQuery";

const CreditCardCard = ({ state, handlerCofirmCard, createUserLoader }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	const totalValue = state.payOptions.totalValue
		? parseFloat(state.payOptions.totalValue).toLocaleString("pt-br", {
				style: "currency",
				currency: "BRL"
			})
		: parseFloat(state.payOptions.value).toLocaleString("pt-br", {
				style: "currency",
				currency: "BRL"
			});
	const paymentForm = state.payOptions.installmentCount
		? `${state.payOptions.installmentCount}x de ${parseFloat(
				state.payOptions.totalValue / state.payOptions.installmentCount
			).toLocaleString("pt-br", {
				style: "currency",
				currency: "BRL"
			})}`
		: "À Vista";
	const cardNumber = `**** **** **** ${state.creditCard.number.slice(-4)}`
	const cvcNumber = `*${state.creditCard.ccv.slice(-2)}`
	const dateCard = `${state.creditCard.expiryMonth}/${state.creditCard.expiryYear.slice(-2)}`
	const cpfNumber = `${state.creditCardHolderInfo.cpfCnpj.slice(0,3)}.${state.creditCardHolderInfo.cpfCnpj.slice(3,6)}.${state.creditCardHolderInfo.cpfCnpj.slice(6,9)}-${state.creditCardHolderInfo.cpfCnpj.slice(-2)}`
	const PAYMENT_CONFIRMATION = [
		{ title: "Valor Total: ", value: totalValue },
		{ title: "Forma de Pagamento:", value: paymentForm },
		{ title: "Cartão:", value: cardNumber },
		{ title: "CVC:", value: cvcNumber },
		{ title: "Validade:", value: dateCard },
		{ title: "Titular do Cartão:", value: state.creditCardHolderInfo.name },
		{ title: "CPF:", value: cpfNumber },
		{ title: "E-mail:", value: state.creditCardHolderInfo.email },

	];
	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
			sx={{
				width: "100%"
			}}
		>
			<Typography variant="h1" color={colors.primary[100]} mb="20px">
				Confirme os dados
			</Typography>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				p="10px"
				sx={{
					gap: "20px",
					width: "100%",
					minHeight: "400px",
					backgroundColor: colors.pink[600],
					border: " 1px solid black",
					borderRadius: "10px",
					padding: "20px",
					"& .MuiInputBase-input": {
						backgroundColor: `${colors.pink[700]} !important`
					},
					"& .MuiFormHelperText-root": {
						color: "red",
						fontStyle: "italic"
					}
				}}
			>
				{PAYMENT_CONFIRMATION.map((payment, index) => {
					return (
						<Box key={index}
							display="flex"
							justifyContent="space-around"
							sx={{
								width: "100%",
								gap: "20px"
							}}
						>
							<Box
								display="flex"
								justifyContent="end"
								sx={{
									width: "80%"
								}}
							>
								<Typography
									variant="h5"
									color={colors.grey[200]}
									sx={{
										whiteSpace: "nowrap"
									}}
								>
									{payment.title}
								</Typography>
							</Box>
							<Box
								display="flex"
								justifyContent="start"
								sx={{
									width: "80%"
								}}
							>
								<Typography
									variant="h5"
									color={colors.greenAccent[200]}
									
								>
									{payment.value}
								</Typography>
							</Box>
						</Box>
					);
				})}
			</Box>
			<LoadingButton
				loading={createUserLoader}
				type="submit"
				sx={{
					backgroundColor: colors.greenAccent[600],
					width: isNonMobile ? "100%" : "100%",
					borderRadius: "60px",
					marginTop: "20px"
				}}
				variant="contained"
				// disabled={!value || value < 10}
				onClick={handlerCofirmCard}
				// disabled={isValid}
			>
				CONFIRMAR
			</LoadingButton>
		</Box>
	);
};

export default CreditCardCard;
